function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.091 11.95l10.284-4.408a.59.59 0 000-1.085L2.091 2.05a.585.585 0 00-.819.536l-.006 2.717c0 .295.218.548.513.584l8.327 1.113L1.78 8.107a.596.596 0 00-.513.59l.006 2.717c0 .418.43.707.82.536z",
  fill: "currentColor"
});

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgSend;